import type { TestShackReportInspection } from "@/pages/products/test-shack/models/TestShackReport";
import { TestShackReportNoSpecLegend } from "@/pages/products/test-shack/shared/components/report/TestShackReportNoSpec";
import { TestShackReportSectionRevCard as SharedSectionRevCard } from "@/pages/products/test-shack/shared/components/report/TestShackReportSectionRevCard";
import type { TestShackReportSectionRev } from "../models/TestShackReportSectionRev";
import { hasMissingSpecs } from "../utils/format";
import { TestShackReportDimensionTable } from "./TestShackReportDimensionTable";
import { TestShackReportDrawingPanel } from "./TestShackReportDrawingPanel";
import type { ImageKind } from "./TestShackReportImageDialog";

interface TestShackReportSectionRevCardProps {
	sectionRev: TestShackReportSectionRev;
	isCollapsed: boolean;
	showMinTargetMax: boolean;
	onToggle: () => void;
	onError: (error: Error) => void;
	onViewImages: (
		inspection: TestShackReportInspection,
		kind: ImageKind,
	) => void;
}

export const TestShackReportSectionRevCard = ({
	sectionRev,
	isCollapsed,
	showMinTargetMax,
	onToggle,
	onError,
	onViewImages,
}: TestShackReportSectionRevCardProps) => (
	<SharedSectionRevCard
		sectionRev={sectionRev}
		isCollapsed={isCollapsed}
		onToggle={onToggle}
		footer={
			hasMissingSpecs(sectionRev.columns) && <TestShackReportNoSpecLegend />
		}
	>
		<TestShackReportDimensionTable
			sectionRev={sectionRev}
			showMinTargetMax={showMinTargetMax}
		/>
		<TestShackReportDrawingPanel
			sectionRev={sectionRev}
			onError={onError}
			onOpen={(kind) => onViewImages(sectionRev.rows[0].inspection, kind)}
		/>
	</SharedSectionRevCard>
);
